import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AuthState {
  loggedIn: boolean;
  token: string;
}

const initialState: AuthState = {
  loggedIn: false,
  token: '',
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStatus: (state, action: PayloadAction<boolean>) => {
      state.loggedIn = action.payload;
    },
    updateTicket: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
  },
});

export const { loginStatus, updateTicket } = authSlice.actions;
export default authSlice.reducer;

// export const authReducer = (state = initialState, action: AuthActions | UserActions): AuthState => {
//   switch (action.type) {
//     case INITIALIZE_USER:
//       return {
//         ...state,
//         loggedIn: true,
//       };

//     case LOGOUT:
//       return initialState;

//     case USER_AUTH_TICKET:
//       return {
//         ...state,
//         token: action.token,
//       };

//     default:
//       return state;
//   }
// };
